import React, { Suspense, lazy } from 'react';
import { CenterLoader } from '../../styles';

const ImageEditor = lazy(() => import(/* webpackChunkName: "image-editor" */ 'react-filerobot-image-editor'));

export const TABS = {
  ANNOTATE: 'Annotate',
  ADJUST: 'Adjust',
  FINETUNE: 'Finetune',
};

export const TOOLS = {
  PEN: 'Pen',
};

export default function FilerobotImageEditor(props) {
  return (
    <Suspense fallback={<CenterLoader />}>
      <ImageEditor {...props} />
    </Suspense>
  );
}
